import TemplateApi from "../api/TemplateApi";
import * as types from "../constants/actionConstants";
import {closeDrawer} from "./drawerActions";
import {initGetTemplateList} from "./templateListActions";
import * as TEMPLATE from "../constants/templateConstants";
import * as portalTypes from "../portal/constants/actionConstants";
import {notificationOpen} from "./notificationActions";
import {runTrackedTemplateSave} from "./templateSaveActions";
import {
    captureEditorOrigin,
    questionEditorAnswerTargetMatches,
    runIfEditorOwnerActive
} from "../utilities/editorInstanceOwnership";


export function getGroupTemplate(groupKey, id) {

    let thunk = (dispatch)=>{
        if (id) {
            TemplateApi.getGroupById(id)
                .then((groupTemplate) => {
                    dispatch({type: types.GROUP_TEMPLATE_GET_SUCCESS, groupTemplate});
                });
        }
        else {
            TemplateApi.getCurrentGroup(groupKey)
                .then((groupTemplate) => {
                    dispatch({type: types.GROUP_TEMPLATE_GET_SUCCESS, groupTemplate});
                });
        }

        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };

    thunk.meta = {
        debounce: {
            time: 2000,
            key: id || groupKey,
            leading: true,
            trailing: false
        }
    };

    return thunk;
}

export function saveGroupTemplate(groupTemplateObject) {
    return (dispatch)=>{
        return runTrackedTemplateSave(dispatch, () =>
            TemplateApi.saveGroupTemplate(groupTemplateObject)
            .then((groupTemplate) =>{
                dispatch({type: types.GROUP_TEMPLATE_UPDATE_SUCCESS , groupTemplate});
                setTimeout(() => {
                    dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
                }, 500);
                return groupTemplate;
            })
        );
    };
}

export function saveGroupTemplateAndCloseDrawer(groupTemplateObject, filter, versionsFilter, templateMode, filterState, requestOwner = null) {
    const owner = captureEditorOrigin(requestOwner);
    return (dispatch, getState)=>{
        return runTrackedTemplateSave(dispatch, () =>
            TemplateApi.saveGroupTemplate(groupTemplateObject)
            .then((groupTemplate) =>{
                dispatch({type: types.GROUP_TEMPLATE_UPDATE_SUCCESS , groupTemplate});
                runIfEditorOwnerActive(getState, owner, () => dispatch(closeDrawer()));

                // Best to load group list page in all cases
                dispatch(initGetTemplateList(filter, TEMPLATE.TYPE.GROUP, TEMPLATE.MODE.CURRENT));
                if (templateMode === TEMPLATE.MODE.VERSIONS) {
                    let tempVersionsFilter = {...versionsFilter};
                    tempVersionsFilter.templateName = groupTemplateObject.name;
                    tempVersionsFilter.templateKey = groupTemplateObject.templateKey;
                    tempVersionsFilter.defaultActions = filterState.defaultActions;
                    dispatch(initGetTemplateList(tempVersionsFilter, TEMPLATE.TYPE.GROUP, TEMPLATE.MODE.VERSIONS));
                }
                return groupTemplate;
            })
        );
    };
}

export function createGroupTemplate(groupTemplateObject, parentOrigin = null) {
    const origin = captureEditorOrigin(parentOrigin);
    return (dispatch, getState) => {
        if (origin && !questionEditorAnswerTargetMatches(origin, getState(), groupTemplateObject.answerIndex)) {
            const error = new Error("Select an active answer before creating a show group.");
            dispatch(notificationOpen(error.message));
            return runTrackedTemplateSave(dispatch, () => Promise.reject(error));
        }
        return runTrackedTemplateSave(dispatch, () =>
            TemplateApi.createGroupTemplate(groupTemplateObject)
            .then((groupTemplate) => {
                dispatch({type: types.GROUP_TEMPLATE_CREATE_SUCCESS, groupTemplate, origin});
                setTimeout(() => {
                    dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
                }, 500);
                if (groupTemplateObject.answerIndex || groupTemplateObject.answerIndex === 0) {
                    dispatch({
                        type: types.QUESTION_EDITOR_ADD_GROUP,
                        groupTemplate,
                        answerIndex: groupTemplateObject.answerIndex,
                        depth: origin?.depth ?? 0,
                        origin
                    });
                }
                return groupTemplate;
            })
        );
    };
}

export function createGroupTemplateAndCloseDrawer(groupTemplateObject, filter, onSuccess = ()=>{}, parentOrigin = null) {
    const origin = captureEditorOrigin(parentOrigin);
    return (dispatch, getState) => {
        if (origin && !questionEditorAnswerTargetMatches(origin, getState(), groupTemplateObject.answerIndex)) {
            const error = new Error("Select an active answer before creating a show group.");
            dispatch(notificationOpen(error.message));
            return runTrackedTemplateSave(dispatch, () => Promise.reject(error));
        }
        return runTrackedTemplateSave(dispatch, () =>
            TemplateApi.createGroupTemplate(groupTemplateObject)
            .then((groupTemplate) => {
                dispatch({type: types.GROUP_TEMPLATE_CREATE_SUCCESS, groupTemplate, origin});

                if (groupTemplateObject.answerIndex || groupTemplateObject.answerIndex === 0) {
                    dispatch({
                        type: types.QUESTION_EDITOR_ADD_GROUP,
                        groupTemplate,
                        answerIndex: groupTemplateObject.answerIndex,
                        depth: origin?.depth ?? 0,
                        origin
                    });
                }
                runIfEditorOwnerActive(getState, origin, () => {
                    onSuccess();
                    dispatch(closeDrawer());
                });
                dispatch(initGetTemplateList(filter, TEMPLATE.TYPE.GROUP, TEMPLATE.MODE.CURRENT));
                return groupTemplate;
            })
        );
    };
}

// ---------------------------------------------------------------------------------------------------------------------
// Groups question keys
// ---------------------------------------------------------------------------------------------------------------------

export function  addGroupTemplateQuestionKey(groupTemplate, questionKey = []) {

    return (dispatch) => {
        dispatch({type: types.GROUP_TEMPLATE_ADD_QUESTION_KEY, groupTemplate: groupTemplate, questionKey: questionKey});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}


//categoryTemplate, removedGroupKey, showGroupKeys = []
export function  setGroupTemplateShowGroupKeys(groupTemplate, removedQuestionKey, showGroupKeys = []) {
    //debugger; // SSSSS Show Group Testing
    return (dispatch) => {
        dispatch({type: types.GROUP_TEMPLATE_SET_SHOW_GROUP_KEYS, groupTemplate: groupTemplate, removedQuestionKey: removedQuestionKey, showGroupKeys: showGroupKeys});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function  removeGroupTemplateQuestionKey(template, questionKey = []) {
    return (dispatch) => {
        dispatch({type: types.GROUP_TEMPLATE_REMOVE_QUESTION_KEY, template: template, questionKey: questionKey});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

// ---------------------------------------------------------------------------------------------------------------------
// Groups show group keys
// ---------------------------------------------------------------------------------------------------------------------

export function  addGroupTemplateShowGroupKeys(groupTemplate, showGroupKeys = []) {
    //debugger; // SSSSS Show Group Testing
    return (dispatch) => {
        dispatch({type: types.GROUP_TEMPLATE_ADD_SHOW_GROUP_KEYS, groupTemplate: groupTemplate, showGroupKeys: showGroupKeys});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function  removeGroupTemplateShowGroupKeys(template, showGroupKeys = []) {
    return (dispatch) => {
        dispatch({type: types.GROUP_TEMPLATE_REMOVE_SHOW_GROUP_KEYS, payload: {template}, showGroupKeys: showGroupKeys});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

// -----------------------------------------------------------------------------------------------------------------
// GRAPH !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! <editor-fold>
// -----------------------------------------------------------------------------------------------------------------

export function getGroupGraph(id) {

    return (dispatch) => {
        TemplateApi.getGroupGraph(id)
            .then((response) => {
                return dispatch({type: types.GET_GROUP_GRAPH_SUCCESS, groupTemplateGraph: response});
            })
            .catch((error) => {
                dispatch({type: types.GET_GROUP_GRAPH_FAILURE});
                console.log(error.message);// eslint-disable-line
            });
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function clearGroupGraph() {
    return (dispatch) => {
        dispatch({type: types.CLEAR_GROUP_GRAPH});
    };
}


export function getGroupGraphWithKey(key) {
    return (dispatch) => {
        TemplateApi.getGroupGraphWithKey(key)
            .then((response) => {
                return dispatch({type: types.GROUP_GRAPH_GET_SUCCESS, groupTemplateGraph: response});
            })
            .catch((error) => {
                dispatch({type: types.GROUP_GRAPH_GET_FAILURE});
                console.log(error.message);// eslint-disable-line
            });
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}


//</editor-fold>
// -----------------------------------------------------------------------------------------------------------------



